import { useLocale } from "../../stores/locale";
import { padLeft } from "../../utils/pad-left";
import { H1 } from "../h1";

export function TimeHeader({ date }: { date: Date }) {
  const localeName = useLocale((state) => state.currentLocaleName);

  return (
    <H1 className="flex items-center gap-2">
      {getDayName(date, localeName)}{" "}
      <span className="text-gray-400">
        {getDay(date)} {getShortMonth(date, localeName)}
      </span>
    </H1>
  );
}
function getDayName(date: Date, localeName: string) {
  return date.toLocaleDateString(localeName, { weekday: "long" });
}

function getShortMonth(date: Date, localeName: string) {
  return date.toLocaleDateString(localeName, { month: "short" });
}

function getDay(date: Date) {
  return padLeft(date.getDate(), 2);
}
